import CSS from './Description.module.scss';
import Coin from '@/components/coins/Coin';
import Vector from '@/components/elements/vector/Vector';
import {getBankInfo} from '@/lib/banks';
import {formatCurrency, formatPANId} from '@/lib/utils';
import {Currency} from '@/types';
import type {Notification} from '@/types/api/notifications';

export default function Description({
  notification,
  className
}: {
  notification: Notification;
  className?: HTMLElement['className'];
}) {
  let bankInfo: ReturnType<typeof getBankInfo>;
  if (notification?.BALANCE_WITHDRAW)
    bankInfo = getBankInfo(undefined, notification.BALANCE_WITHDRAW.cardNo);

  return (
    <div className={`${CSS.description} ${className || ''}`}>
      {notification.BALANCE_WITHDRAW ? (
        <>
          مقدار &nbsp;
          <strong>
            {formatCurrency(notification.BALANCE_WITHDRAW.amount, Currency.IRT)}
          </strong>
          &nbsp; تومان از حساب کاربری شما به شماره کارت &nbsp;
          <strong>
            <bdi className={CSS.panId}>
              {formatPANId(notification.BALANCE_WITHDRAW.cardNo)}
            </bdi>
          </strong>
          {!!bankInfo && (
            <>
              &nbsp; در &nbsp;
              <strong>
                {bankInfo.name}
                &nbsp;
                <Vector className={CSS.bankIcon} name={bankInfo.vectorName} />
              </strong>
            </>
          )}
          &nbsp; با احتساب &nbsp;
          <strong>
            {formatCurrency(notification.BALANCE_WITHDRAW.wage, Currency.IRT)}
          </strong>
          &nbsp; تومان کارمزد انتقال یافت.
        </>
      ) : notification.BALANCE_DEPOSIT ? (
        <>
          مقدار &nbsp;
          <strong>
            {formatCurrency(notification.BALANCE_DEPOSIT.amount, Currency.IRT)}
          </strong>
          &nbsp; تومان با احتساب &nbsp;
          <strong>
            {formatCurrency(notification.BALANCE_DEPOSIT.wage, Currency.IRT)}
          </strong>
          &nbsp; تومان به حساب کاربری شما اضافه گردید.
        </>
      ) : notification.COIN_DEPOSIT ? (
        <>
          مقدار &nbsp;
          <strong>{formatCurrency(notification.COIN_DEPOSIT.amount)}</strong>
          &nbsp;
          <Coin id={notification.COIN_DEPOSIT.coin} iconSize="1.5rem" />
          &nbsp; در شبکه
          <Coin
            id={notification.COIN_DEPOSIT.network}
            iconSize="1.5rem"
            isNetwork
          />
          &nbsp; از آدرس &nbsp;
          <strong>
            <code>{notification.COIN_DEPOSIT.address}</code>
          </strong>
          &nbsp; به حساب کاربری شما انتقال یافت.
        </>
      ) : notification.COIN_WITHDRAW ? (
        <>
          مقدار &nbsp;
          <strong>{formatCurrency(notification.COIN_WITHDRAW.amount)}</strong>
          &nbsp;
          <Coin id={notification.COIN_WITHDRAW.coin} iconSize="1.5rem" />
          &nbsp; در شبکه &nbsp;
          <Coin
            id={notification.COIN_WITHDRAW.network}
            iconSize="1.5rem"
            isNetwork
          />
          &nbsp; از حساب کاربری شما به آدرس &nbsp;
          <strong>
            <code>{notification.COIN_WITHDRAW.address}</code>
          </strong>
          &nbsp; انتقال یافت.
        </>
      ) : notification.CUSTOMER_LOYALTY_PROGRAM_KYC_GIFT ? (
        <>
          مقدار &nbsp;
          <strong>
            {formatCurrency(
              notification.CUSTOMER_LOYALTY_PROGRAM_KYC_GIFT.amount
            )}
          </strong>
          &nbsp;
          <Coin
            id={notification.CUSTOMER_LOYALTY_PROGRAM_KYC_GIFT.coin}
            iconSize="1.5rem"
          />
          &nbsp; هدیه تکمیل احراز هویت به حساب کاربری شما انتقال یافت.
        </>
      ) : notification.body ? (
        notification.body
      ) : null}
    </div>
  );
}
